import React from 'react';
import { useFeatureValue } from '@shared/core/featureFlags';
import { HotelDetails as Root } from './HotelDetails';
import { HotelBookingPartner } from '../HotelBookingPartner/HotelBookingPartner';
import { JoyLogoLoader } from '@shared/components/JoyLogoLoader';

const HotelDetails = ({ joyPlaceId, eventHandle }: { joyPlaceId?: string; eventHandle?: string }) => {
  // @todo - Cleanup with ticket - https://withjoy.atlassian.net/browse/TRAV-622
  const { value, loading } = useFeatureValue('hotelNewRoutesEnabled');
  const hotelNewRoutesEnabled = value === 'on';
  return (
    <>
      {loading ? (
        <JoyLogoLoader loaderKey="hotel-details-new-flag" />
      ) : hotelNewRoutesEnabled ? (
        <Root joyPlaceId={joyPlaceId} eventHandle={eventHandle} />
      ) : (
        <HotelBookingPartner hotelId={joyPlaceId} />
      )}
    </>
  );
};

export default HotelDetails;
